const getDefaultState = () => {
  return {
    metadata: {},
    step: 1,
    merchandiseBO: 0,
    //MachuPicchu
    listEventsMP: [],
    activityID: 0,
    countries: [],
    listRoutesCircuits: [],
    listGeneral: [],
    countriesS3: [],
  };
};

// initial state
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_METADATA(state, payload) {
    state.metadata = payload;
  },
  CHANGE_STEP(state, payload) {
    state.step = payload;
  },
  ADD_MERCHANDISEBO(state, payload) {
    state.merchandiseBO = payload;
  },
  SET_LIST_EVENTS(state, payload) {
    const { data, access } = payload;
    state.listGeneral = data;
    let routes = {
      name: 'Rutas - CAMINO INCA',
      url_key: '/reservations',
      type: 'route',
      childs: [],
    };
    let circuits = {
      name: 'Rutas - LLAQTA DE MACHUPICCHU',
      url_key: '/circuits',
      type: 'circuit',
      childs: [],
    };
    let typeGroupIdCircuits = [];
    let allCircuits = [];

    data.forEach((el) => {
      if (el.typeGroupType === 'circuit') {
        typeGroupIdCircuits.push(el);
        allCircuits.push(el);
      } else {
        routes.childs.push(el);
      }
    });
    let hash = {};
    typeGroupIdCircuits = typeGroupIdCircuits.filter((o) =>
      hash[o.typeGroupId] ? false : (hash[o.typeGroupId] = true),
    );
    typeGroupIdCircuits.forEach((u) => {
      let { typeGroupId, typeGroupName, categoryDescription, typeGroupImageUrl, relationId } = u;
      let circuitItem = {
        typeGroupId: typeGroupId,
        typeGroupName: typeGroupName,
        typeGroupImageUrl: typeGroupImageUrl,
        description: categoryDescription,
        relationId: relationId,
        list: [],
      };
      for (const element of allCircuits) {
        const el = element;
        if (el.typeGroupId === typeGroupId) {
          circuitItem.list.push(el);
        }
      }
      circuits.childs.push(circuitItem);
    });
    if (access && access.includes('circuit')) {
      state.listEventsMP.push(circuits);
    }
    if (access && access.includes('route')) {
      state.listEventsMP.push(routes);
    }
  },
  SET_ACTIVITY_ID(state, payload) {
    state.activityID = payload;
  },
  SET_LIST_COUNTRIES(state, payload) {
    state.countries = payload;
  },
  SET_LIST_COUNTRIES_S3(state, payload) {
    state.countriesS3 = payload;
  },
  SET_LIST_ROUTES_CIRCUITS(state, payload) {
    state.listRoutesCircuits = payload;
  },
};

const actions = {
  resetState({ commit }) {
    commit('RESET_STATE');
  },
  addMetadata({ commit }, payload) {
    commit('ADD_METADATA', payload);
  },
  changeStep({ commit }, payload) {
    commit('CHANGE_STEP', payload);
  },
  addMerchandiseBO({ commit }, payload) {
    commit('ADD_MERCHANDISEBO', payload);
  },
  setListEvents({ commit }, payload) {
    commit('SET_LIST_EVENTS', payload);
  },
  setListCountries({ commit }, payload) {
    commit('SET_LIST_COUNTRIES', payload);
  },
  setListCountriesS3({ commit }, payload) {
    commit('SET_LIST_COUNTRIES_S3', payload);
  },
  setListRoutesCircuits({ commit }, payload) {
    commit('SET_LIST_ROUTES_CIRCUITS', payload);
  },
};

export default {
  state,
  getters: {
    getMetadata(state) {
      return state.metadata;
    },
    getMerchandiseBO(state) {
      return state.merchandiseBO;
    },
    getListEvents(state) {
      return state.listEventsMP;
    },
    getActivityId(state) {
      return state.activityID;
    },
    getListCountries(state) {
      return state.countries;
    },
    getListCountriesS3(state) {
      return state.countriesS3;
    },
    getListRoutesCircuits(state) {
      return state.listRoutesCircuits;
    },
    getListGeneral(state) {
      return state.listGeneral;
    },
  },
  actions,
  mutations,
};
